import { computed } from 'vue';
import { getMetaAdvancedMatchingData } from '~/utils/facebook';
import { resolveInjected } from '~/utils/nuxt-instance';
/**
 * Meta (Facebook) pixel helpers. The organizer is passed in per call.
 */
export function useMetaPixel() {
  var userAcceptedMarketing = computed(function () {
    return resolveInjected('$CookieConsent').acceptedCategory('marketing');
  });
  // We have to take into consideration the cases where the FB lib is not loaded, due to ENABLE_META_PIXEL
  var fb = resolveInjected('$fb');
  function canTrack() {
    return !!fb && useFeatureFlags().enableMetaTracking && userAcceptedMarketing.value;
  }
  function setupMetaPixel(organizer) {
    if (!canTrack() || !(organizer !== null && organizer !== void 0 && organizer.metaPixelId)) return;
    var auth = useAuth();
    if (fb.options.pixelId !== organizer.metaPixelId) {
      fb.setPixelId(organizer.metaPixelId);
    }
    if (auth.loggedIn) {
      fb.setUserData(getMetaAdvancedMatchingData(auth.user));
    }
    fb.enable();
  }
  function disableMetaPixel(organizer) {
    if (!fb) return;
    if (organizer !== null && organizer !== void 0 && organizer.metaPixelId || !userAcceptedMarketing.value) {
      fb.disable();
    }
  }

  /**
   * Tracks an event on the pixel enabled by setupMetaPixel. Never throws: tracking
   * must not break anything else.
   */
  function trackMetaEvent(event, data, options) {
    if (!canTrack()) return;
    try {
      fb.track(event, data, options);
    } catch (e) {
      console.warn('Meta pixel tracking failed:', e);
    }
  }

  /**
   * Tracks an event on the platform pixel. Enables it just for this event, then
   * disables it again. Never throws.
   */
  function trackPlatformMetaEvent(event, data) {
    if (!canTrack()) return;
    var _useFeatureFlags = useFeatureFlags(),
      metaPixelId = _useFeatureFlags.metaPixelId;
    try {
      if (fb.options.pixelId !== metaPixelId) {
        fb.init(metaPixelId);
      }
      fb.enable();
      fb.track(event, data);
      fb.disable();
    } catch (e) {
      console.warn('Meta pixel tracking failed:', e);
    }
  }
  return {
    setupMetaPixel: setupMetaPixel,
    disableMetaPixel: disableMetaPixel,
    trackMetaEvent: trackMetaEvent,
    trackPlatformMetaEvent: trackPlatformMetaEvent
  };
}